import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ROUTE_LOGIN } from 'constants/routerPath.js';
import { UserData } from 'types/userInfoTypes';

interface ProtectedRouteProps {
	children: ReactNode;
	userData: UserData | null;
}

/**
 * @component ProtectedRoute
 * @desc Protects routes by checking if userData exists. Redirects to login if userData is null.
 * @returns {JSX.Element}
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
	children,
	userData,
}) => {
	const location = useLocation(); // Get the current location

	// Redirect to login and preserve the original route
	if (userData?.userId === '') {
		return <Navigate to={ROUTE_LOGIN} state={{ from: location }} replace />;
	}

	return <>{children}</>;
};

export default ProtectedRoute;
